import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Fingerprint01 = function Fingerprint01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7.4264 3.247C8.7667 2.4548 10.3302 2 12 2c4.9706 0 9 4.0294 9 9 0 .0298-.0001.0596-.0004.0894M4.243 6.4333C3.4532 7.772 3 9.333 3 11c0 4.1936 2.8682 7.7174 6.75 8.7165m10.0869-4.288c-1.1884 2.0985-3.1953 3.6724-5.5869 4.288m-.3696-13.7801A5.3891 5.3891 0 0 0 12 5.6c-2.9823 0-5.4 2.4177-5.4 5.4 0 .6649.1202 1.3017.34 1.8899m10.1226-3.773A5.3882 5.3882 0 0 1 17.4 11c0 2.9823-2.4177 5.4-5.4 5.4a5.3878 5.3878 0 0 1-1.8686-.3321M12 9.2v3.6"
    })
  }));
};
export default Fingerprint01;